import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "../commonsActions";
import {getPromoterSettings, savePromoterSettings, updatePromoterSettings} from "../../helpers/promoterSettingsService";

export const FETCH_PROMOTER_SETTINGS_BEGIN = 'FETCH_PROMOTER_SETTINGS_BEGIN';
export const FETCH_PROMOTER_SETTINGS_SUCCESS = 'FETCH_PROMOTER_SETTINGS_SUCCESS';
export const FETCH_PROMOTER_SETTINGS_ERROR = 'FETCH_PROMOTER_SETTINGS_ERROR';


const fetchPromoterSettingsSuccess = res => ({
    type: FETCH_PROMOTER_SETTINGS_SUCCESS,
    payload: {
        promoterSettings: res.data,
    }
});

const fetchPromoterSettingsError = error => ({
    type: FETCH_PROMOTER_SETTINGS_ERROR,
    payload: {
        error: error,
    }
});

export const fetchPromoterSettings = query => dispatch => {
    dispatch({type: FETCH_PROMOTER_SETTINGS_BEGIN});
    return getPromoterSettings(query).then(res => {
        dispatch(fetchPromoterSettingsSuccess(res));
        return res;
    }, error => {
        dispatch(fetchPromoterSettingsError(error))
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const saveNewPromoterSettings = settings => dispatch => {
    return savePromoterSettings(settings).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const updateSinglePromoterSettings = settings => dispatch => {
    return updatePromoterSettings(settings).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoter/promoterSettingsActions.js